import { getLanguageMatch, getUserLanguageCode, toLanguageCode } from 'js/lib/language';
import { isAuthenticatedUser } from 'js/lib/user';

import type { Languages } from 'bundles/unified-description-page-common/providers/LanguageInfoDialogProvider';

import _t from 'i18n!nls/xdp';

export const getAudienceLanguageCode = (dubbedLanguages: Languages['dubbedLanguages']) => {
  const languageCode = toLanguageCode(isAuthenticatedUser() ? getUserLanguageCode() : _t.getLocale());
  return dubbedLanguages?.map((lang) => lang.languageCode)?.some((lang) => getLanguageMatch(lang, languageCode))
    ? languageCode
    : null;
};
